(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-stpr-popup-main-goods"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Flickity === "undefined") return;

  document.querySelectorAll(".stpr-popup-lp-main-goods__lineup").forEach((lineup) => {
    const initOrResizeSlider = (tab) => {
      const content = tab.nextElementSibling;
      const slider = content.querySelector(".tgtp-blk-stpr-popup-main-goods-item-tab-content__list");
      if (!slider) return;

      requestAnimationFrame(() => {
        const existing = Flickity.data(slider);
        if (existing) {
          existing.resize();
          return;
        }

        const flkty = new Flickity(slider, {
          prevNextButtons: false,
          pageDots: false,
          cellAlign: "left",
          contain: true,
        });

        slider.querySelectorAll("li").forEach((li) => {
          li.style.width = `${flkty.size.width}px`;
        });
        flkty.resize();

        const dotsContainer = content.querySelector(".tgtp-blk-stpr-popup-main-goods-item-tab-content__nav-dots");
        const dotClass = "tgtp-blk-stpr-popup-main-goods-item-tab-content__nav-dot";

        flkty.slides.forEach((_, i) => {
          const li = document.createElement("li");
          const btn = document.createElement("button");
          btn.type = "button";
          btn.classList.add(dotClass);
          btn.setAttribute("aria-label", `スライド ${i + 1} へ`);
          if (i === 0) btn.classList.add("is-selected");
          btn.addEventListener("click", () => flkty.select(i));
          li.appendChild(btn);
          dotsContainer.appendChild(li);
        });

        flkty.on("change", (index) => {
          dotsContainer.querySelectorAll(`.${dotClass}`).forEach((btn, i) => {
            btn.classList.toggle("is-selected", i === index);
          });
        });

        content.querySelector(".tgtp-blk-stpr-popup-main-goods-item-tab-content__nav-btn--prev")
          .addEventListener("click", () => flkty.previous());
        content.querySelector(".tgtp-blk-stpr-popup-main-goods-item-tab-content__nav-btn--next")
          .addEventListener("click", () => flkty.next());
      });
    };

    const openTab = (tab) => {
      lineup.querySelectorAll(".tgtp-blk-stpr-popup-main-goods-item-tab").forEach((el) => {
        el.setAttribute("aria-expanded", "false");
      });

      tab.setAttribute("aria-expanded", "true");
      initOrResizeSlider(tab);
    };

    const firstTab = lineup.querySelector(".tgtp-blk-stpr-popup-main-goods-item-tab");
    if (firstTab) {
      openTab(firstTab);
    }

    lineup.querySelectorAll(".tgtp-blk-stpr-popup-main-goods-item-tab").forEach((tab) => {
      tab.addEventListener("click", () => openTab(tab));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-stpr-popup-title"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hero = document.querySelector(".tgtp-stpr-popup-title__hero");
    if (hero) {
      hero.classList.add("is-animate");
    }
  });

  } catch(e) { console.error(e); }
})();
})();
